import styled from 'styled-components';
import Text14 from '@sdk/components/ui/typography/Text14';

export const ClickableText = styled(Text14)`
  cursor: pointer;
`;
